
import eventNames from '@/features/common/constants/events';
import eventBus from '@/features/common/eventBus';
import { showErrorAlertDialog, showSuccessAlertDialog } from '@/features/common/helpers';
import { Vue, Component } from 'vue-property-decorator';
import { addUPSMerchantAccount } from '../services/merchantRegistration.services';

@Component
export default class UPSMyAccountIntegration extends Vue {
  mounted(): void {
    const code = this.getCode();
    if (!code) return;

    this.installUpsMyAccount(code);
  }

  private getCode() {
    return this.$route.query.code as string || '';
  }

  private installUpsMyAccount = async (code: string) => {
    const response = await addUPSMerchantAccount(code);
    if (!response.successful || !response.data) {
      showErrorAlertDialog(response.errorMessage);
      return;
    }

    eventBus.$emit(eventNames.FETCH_CARRIER_ACCOUNTS);

    showSuccessAlertDialog(this.$t('carrierAccounts.addAccount.alertDialog.successfulAddition') as string);
  }
}
